// extracted by mini-css-extract-plugin
export default {"authApprovalConfirmation":"AuthorizationConfirmation_authApprovalConfirmation__oNpWQ","authReviewConfirmation":"AuthorizationConfirmation_authReviewConfirmation__VfqLg"};